function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRoomCourtyardViewFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 2H3c-.55 0-1 .45-1 1v26c0 .55.45 1 1 1h26c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1zM4 4h24v15.24l-2.36-2.83C26.48 15.52 27 14.32 27 13v-3c0-2.76-2.24-5-5-5s-5 2.24-5 5v3c0 .98.29 1.88.78 2.65-.13-.21-.26-.43-.36-.65H4V4zm18 12c-1.66 0-3-1.34-3-3v-3c0-1.66 1.34-3 3-3s3 1.34 3 3v3c0 1.66-1.34 3-3 3zM4 28V17h15.03c.58.43 1.24.75 1.97.9V24h2v-6.1c.35-.07.69-.19 1.01-.33L28 22.36V28H4z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 19v3H7v4h2v-2h5v2h2v-2h1v2h2v-7H9zm8 3h-6v-1h6v1z",
    fill: props.color
  }));
}

export default SvgIconRoomCourtyardViewFilled;